export default function ($translate) {
    return {
        KEYS: {
            INCOMPLETE: 'INCOMPLETE',
            COMPLETED: 'COMPLETED'
        },
        LABELS: {
            INCOMPLETE: $translate.instant('tasklist.status.Incomplete'),
            COMPLETED: $translate.instant('tasklist.status.Completed')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/tasklist/task/status/index.js